let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b3QLW")).then(() => parcelRequire('7EwAQ'));